import React, {Component} from 'react';
import {connect} from 'react-redux';
import SolicitorHomePage from "../../components/solicitorHomePage";
import {
	requestGetArticleAttachment, requestGetArticles,
	requestGetArticlesSolicitorHomePage
} from "../../actions/articlesList";
import {push} from "connected-react-router";
import {getSolicitorImages} from "../../actions/solicitorImages";
import {_getFileFromBase64} from "../../helpers/functions";
import {isAgent} from "../../helpers/functions";

// var download = require('in-browser-download');

class SolicitorHomePageHOC extends Component {

	componentWillMount() {
		let parameters = {
			limit: 3,
			offset: 0,
			published: true,
			unpublished: false,
			search: null
		};
		if(isAgent(this.props.userRoles))
			this.props.requestGetArticlesSolicitorHomePage(parameters);


	}

	componentWillReceiveProps = (nextProps) => {
		if(this.props.articlesList.fetchingDocument && !nextProps.articlesList.fetchingDocument && nextProps.articlesList.failedToGetDocumentMsg === ''){
			_getFileFromBase64(nextProps.articlesList.documentToDownload);
		}
	};

	// getFileFromBase64 = (documentToDownload) => {
	// 	download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
	// };


	render() {
		return(
			(isAgent(this.props.userRoles))?
        <SolicitorHomePage
          requestGetArticleAttachment = {this.props.requestGetArticleAttachment}
          failedToReceivePendingTobaMsg={this.props.failedToReceivePendingTobaMsg}
          push={this.props.push}
          articles={this.props.solicitorArticlesList.homePageArticles}
        />
				:
				null
		)
	}

}

const mapStateToProps = (state) => {
	return {
		userRoles: state.user.loggedInUser.roles,
		loggedInUser: state.user.loggedInUser.roles[0],
		solicitorArticlesList: state.solicitorArticlesList,
		failedToReceivePendingTobaMsg: state.user.failedToReceivePendingTobaMsg,
		articlesList: state.articlesList
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		requestGetArticlesSolicitorHomePage: (payload) => {
			dispatch(requestGetArticlesSolicitorHomePage(payload))
		},
		push: (url) => {
			dispatch(push(url))
		},
		requestGetArticleAttachment: (payload) => {
			dispatch(requestGetArticleAttachment(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorHomePageHOC);
